<template>
	<div>
		<img :src="file_path" alt="덴탈클라우드 의뢰서" style="max-width:100%;">
	</div>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const route = useRoute();
const router = useRouter();

const today = moment().format('YYYY-MM-DD');

const file_path = ref(route.query.file_path);
watch(
	() => route.query.file_path,
	(newVal) => {
		file_path.value = newVal;
		setTimeout(() => {
			commonjs.winPrint();
		}, 500);
	}
);
//const title = ref(route.query.title);

onMounted(async () => {
	setTimeout(() => {
		commonjs.winPrint();
	}, 500);
});
</script>